import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { start, setScrollLocation } from '../../common/app/actions'
import meta from './meta'

import './App.scss'

// routes
import routes, { SwitchWithRoutes } from './routes'

//eslint-disable-next-line
class App extends React.Component {
  componentDidMount() {
    const { start } = this.props
    start()
  }

  render() {
    const { errors } = this.props

    const notFound = errors.filter(e => e.code === 404).size > 0

    return (
      <div className="app-container">
        <Helmet
          htmlAttributes={{ lang: 'cs' }}
          titleTemplate={meta.title}
          meta={meta.metas}
          link={meta.links}
        />
        <SwitchWithRoutes routes={routes} resourceNotFound={notFound} />
      </div>
    )
  }
}

App.propTypes = {
  errors: React.PropTypes.object.isRequired,
  setScrollLocation: React.PropTypes.func.isRequired,
  start: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  errors: state.app.errors,
}), {
  setScrollLocation,
  start,
})(App)



// WEBPACK FOOTER //
// ./src/browser/app/App.js